import {
  // Navigation & Layout
  LayoutDashboard,
  LayoutGrid,
  Menu,
  X,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  ChevronsUpDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  ExternalLink,
  MoreVertical,
  MoreHorizontal,
  GripVertical,
  GripHorizontal,
  CircleArrowLeft,
  PanelLeft,
  PanelLeftClose,

  // Actions
  Plus,
  CirclePlus,
  Minus,
  Pencil,
  Edit,
  Eraser,
  Trash2,
  Trash,
  Copy,
  Save,
  Download,
  Upload,
  FileUp,
  Search,
  Filter,
  RefreshCw,
  RotateCcw,
  Check,
  XCircle,
  CalendarRange,
  Repeat,
  RotateCw,
  Shuffle,
  Play,
  Pause,

  // Time & Calendar
  Calendar,
  CalendarDays,
  CalendarClock,
  CalendarCheck,
  CalendarX,
  CalendarPlus,
  CalendarOff,
  Clock,
  Timer,
  History,
  Hourglass,

  // Users & People
  User,
  Users,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  UserCog,
  UserSearch,
  Contact,
  CircleUser,
  Headphones,

  // Communication
  Bell,
  BellOff,
  BellRing,
  Mail,
  MailOpen,
  MessageSquare,
  MessageCircle,
  Phone,
  PhoneCall,
  PhoneOutgoing,
  Video,
  Send,

  // Status & Feedback
  CheckCircle,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Ban,
  ShieldCheck,
  ShieldAlert,
  Shield,
  CircleCheckBig,
  Siren,
  Loader2,
  Circle,

  // Business & Commerce
  Building,
  Building2,
  Briefcase,
  CreditCard,
  Wallet,
  Receipt,
  BanknoteArrowUp,
  Package,
  Crown,
  ShoppingCart,
  Store,
  Tag,
  Tags,
  Percent,
  Gift,
  ClipboardList,
  Euro,
  Handshake,
  BookOpen,

  // Settings & Configuration
  Settings,
  Settings2,
  Sliders,
  SlidersHorizontal,
  Cog,
  Wrench,
  Key,
  Lock,
  LockOpen,
  Unlock,
  Eye,
  EyeOff,
  Globe,
  Languages,
  Puzzle,
  GitBranch,
  FileCode,
  LayoutTemplate,
  Blocks,
  Plug,
  Palette,
  Database,
  Fingerprint,

  // Data & Files
  Paperclip,
  File,
  FileText,
  FileSpreadsheet,
  Folder,
  FolderOpen,
  FolderPlus,
  BarChart,
  BarChart2,
  BarChart3,
  ChartLine,
  ChartNoAxesCombined,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  FileDown,
  Gauge,

  // Media & Content
  Image,
  Camera,
  Square,
  CheckSquare,
  Star,
  Heart,
  Bookmark,
  Flag,
  PlayCircle,
  Youtube,

  // Location & Maps
  MapPin,
  Map,
  Navigation,
  Compass,
  Home,

  // Technology
  Monitor,
  Smartphone,
  Tablet,
  Laptop,
  Wifi,
  WifiOff,
  Bluetooth,
  Zap,
  Power,
  QrCode,
  Link,
  Link2,
  Unlink,
  MousePointerClick,

  // Misc
  Sparkles,
  Lightbulb,
  Sun,
  Moon,
  Cloud,
  CloudOff,
  Layers,
  Layout,
  Grid,
  Grid3X3,
  List,
  LogOut,
  LogIn,
  Share,
  Share2,
  Maximize,
  Maximize2,
  MonitorSmartphone,
  Minimize,
  Minimize2,
  WrapText,
  Move,
  Grip,
  Hash,
  AtSign,
  Paintbrush,
  Wand2,
  Bot,
  Webhook,
  Code,
  Terminal,
  Activity,
  ArrowRightLeft,
  Plane,
  Rocket,
  Target,
  Megaphone,
  Dot,

  // Arrows and Indicators
  MoveUp,
  MoveDown,
  MoveLeft,
  MoveRight,
  ArrowUpRight,
  ArrowDownRight,
  CornerDownRight,
  CornerRightDown,

  // Table/List Operations
  ListFilter,
  ListOrdered,
  SortAsc,
  SortDesc,
  Columns,
  Columns3,
  Rows,
  Network,
  Braces,
} from 'lucide-angular';

/**
 * Lucide Icons Registry
 *
 * All icons used in Lovable design are registered here.
 * Icons are tree-shakeable - only imported icons are included in the bundle.
 *
 * Usage: <calio-mat-icon iconType="calendar" /> or <calio-lucide-icon name="calendar" />
 *
 * Find icons at: https://lucide.dev/icons
 */
export const LUCIDE_ICONS = {
  // Navigation & Layout
  LayoutDashboard,
  LayoutGrid,
  Menu,
  X,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ChevronUp,
  ChevronsUpDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
  ExternalLink,
  MoreVertical,
  MoreHorizontal,
  GripVertical,
  GripHorizontal,
  CircleArrowLeft,
  PanelLeft,
  PanelLeftClose,

  // Actions
  Plus,
  CirclePlus,
  Minus,
  Pencil,
  Edit,
  Eraser,
  Trash2,
  Trash,
  Copy,
  Save,
  Download,
  Upload,
  FileUp,
  Search,
  Filter,
  RefreshCw,
  RotateCcw,
  Check,
  XCircle,
  CalendarRange,
  Repeat,
  RotateCw,
  Shuffle,
  Play,
  Pause,

  // Time & Calendar
  Calendar,
  CalendarDays,
  CalendarClock,
  CalendarCheck,
  CalendarX,
  CalendarPlus,
  CalendarOff,
  Clock,
  Timer,
  History,
  Hourglass,

  // Users & People
  User,
  Users,
  UserPlus,
  UserMinus,
  UserCheck,
  UserX,
  UserCog,
  UserSearch,
  Contact,
  CircleUser,
  Headphones,

  // Communication
  Bell,
  BellOff,
  BellRing,
  Mail,
  MailOpen,
  MessageSquare,
  MessageCircle,
  Phone,
  PhoneCall,
  PhoneOutgoing,
  Video,
  Send,

  // Status & Feedback
  CheckCircle,
  CheckCircle2,
  AlertCircle,
  AlertTriangle,
  Info,
  HelpCircle,
  Ban,
  ShieldCheck,
  ShieldAlert,
  Shield,
  CircleCheckBig,
  Siren,
  Loader2,
  Circle,

  // Business & Commerce
  Building,
  Building2,
  Briefcase,
  CreditCard,
  Wallet,
  Receipt,
  BanknoteArrowUp,
  Package,
  Crown,
  ShoppingCart,
  Store,
  Tag,
  Tags,
  Percent,
  Gift,
  ClipboardList,
  Euro,
  Handshake,
  BookOpen,

  // Settings & Configuration
  Settings,
  Settings2,
  Sliders,
  SlidersHorizontal,
  Cog,
  Wrench,
  Key,
  Lock,
  LockOpen,
  Unlock,
  Eye,
  EyeOff,
  Globe,
  Languages,
  Puzzle,
  GitBranch,
  FileCode,
  LayoutTemplate,
  Blocks,
  Plug,
  Palette,
  Database,
  Fingerprint,

  // Data & Files
  Paperclip,
  File,
  FileText,
  FileSpreadsheet,
  Folder,
  FolderOpen,
  FolderPlus,
  BarChart,
  BarChart2,
  BarChart3,
  ChartLine,
  ChartNoAxesCombined,
  LineChart,
  PieChart,
  TrendingUp,
  TrendingDown,
  FileDown,
  Gauge,

  // Media & Content
  Image,
  Camera,
  Square,
  CheckSquare,
  Star,
  Heart,
  Bookmark,
  Flag,
  PlayCircle,
  Youtube,

  // Location & Maps
  MapPin,
  Map,
  Navigation,
  Compass,
  Home,

  // Technology
  Monitor,
  Smartphone,
  Tablet,
  Laptop,
  Wifi,
  WifiOff,
  Bluetooth,
  Zap,
  Power,
  QrCode,
  Link,
  Link2,
  Unlink,
  MousePointerClick,

  // Misc
  Sparkles,
  Lightbulb,
  Sun,
  Moon,
  Cloud,
  CloudOff,
  Layers,
  Layout,
  Grid,
  Grid3X3,
  List,
  LogOut,
  LogIn,
  Share,
  Share2,
  Maximize,
  Maximize2,
  MonitorSmartphone,
  Minimize,
  Minimize2,
  WrapText,
  Move,
  Grip,
  Hash,
  AtSign,
  Paintbrush,
  Wand2,
  Bot,
  Webhook,
  Code,
  Terminal,
  Activity,
  ArrowRightLeft,
  Plane,
  Rocket,
  Target,
  Megaphone,
  Dot,

  // Arrows and Indicators
  MoveUp,
  MoveDown,
  MoveLeft,
  MoveRight,
  ArrowUpRight,
  ArrowDownRight,
  CornerDownRight,
  CornerRightDown,

  // Table/List Operations
  ListFilter,
  ListOrdered,
  SortAsc,
  SortDesc,
  Columns,
  Columns3,
  Rows,
  Network,
  Braces,
};

/**
 * Icon name mapping from calio-mat-icon iconType to Lucide names
 *
 * Maps old iconType values (used in calio-mat-icon) to Lucide kebab-case names.
 * When calio-mat-icon receives an iconType that exists here, it renders Lucide.
 * Icons without a mapping fall back to the original SVG icon.
 *
 * IMPORTANT: Add new mappings here as you migrate icons.
 */
/**
 * Icon name mapping from calio-mat-icon iconType to Lucide names
 *
 * Maps old iconType values (used in calio-mat-icon) to Lucide kebab-case names.
 * When calio-mat-icon receives an iconType that exists here, it renders Lucide.
 * Icons without a mapping fall back to the original SVG icon.
 *
 * Based on Lovable redesign: C:\Users\Chirag\Desktop\calenso-dashboard-redesign\src\
 *
 * IMPORTANT: Add new mappings here as you migrate icons.
 */
export const ICON_NAME_MAPPING: Record<string, string> = {
  // ============================================
  // Navigation & Layout
  // ============================================
  'dashboard': 'layout-dashboard',
  'menu': 'menu',
  'close': 'x',
  'xmark': 'x',
  'times': 'x',
  'window-close': 'x',
  'arrow_circle_left': 'circle-arrow-left',
  'arrow_forward': 'arrow-right',
  'arrow_back': 'arrow-left',
  'arrow_right': 'arrow-right',
  'arrow-left': 'arrow-left',
  'chevron_forward': 'chevron-right',
  'chevron_back': 'chevron-left',
  'chevron-down': 'chevron-down',
  'chevron-up': 'chevron-up',
  'chevron-left': 'chevron-left',
  'chevron-right': 'chevron-right',
  'angle-up': 'chevron-up',
  'angle-down': 'chevron-down',
  'external_link': 'external-link',
  'external-link-alt': 'external-link',
  'open_in_new': 'external-link',

  // ============================================
  // Calendar & Time (Lovable: Calendar, CalendarClock, CalendarOff, Clock)
  // ============================================
  'calendar': 'calendar',
  'appointment': 'calendar-clock',
  'schedule': 'calendar-clock',
  'calendar_settings': 'calendar-days',
  'calendar-user': 'calendar',
  'booking': 'calendar-plus',
  'event_busy': 'calendar-x',
  'calendar_off': 'plane',
  'cancel_appointment': 'calendar-x',
  'appointment-cancel': 'calendar-x',
  'appointment-created': 'calendar-plus',
  'appointment-created-with-status': 'calendar-plus',
  'appointment-rebook': 'repeat',
  'appointment-cancelled': 'calendar-x',
  'appointment-changed': 'calendar-check',
  'event-appointment-created': 'calendar-plus',
  'event-appointment-rebooked': 'repeat',
  'event-appointment-cancelled': 'calendar-x',
  'waiting-list-cancelled': 'calendar-x',
  'waiting-list-confirmed': 'calendar-check',
  'event-appointment': 'calendar-clock',
  'group_appointment': 'layers',
  'slot-cancelled': 'calendar-x',
  'booking-limit-reached': 'ban',
  'download-appointment': 'file-down',
  'book-another-appointment': 'calendar-range',
  'rebook': 'repeat',
  'history': 'history',
  'clock': 'clock',
  'clock_outline': 'clock',
  'cron': 'timer',
  'touch_long': 'monitor-smartphone',

  // ============================================
  // Users & People (Lovable: User, Users, UserPlus, UserCheck, UserX)
  // ============================================
  'customer-created': 'user-plus',
  'customer-updated': 'user-check',
  'customer-deleted': 'user-x',
  'customer-imported': 'file-spreadsheet',
  'customer-reached-bookings': 'user-check',
  'customer-no-bookings': 'user-minus',
  'customer-spent': 'receipt',
  'customer-birthday': 'gift',
  'coupon-created': 'tag',
  'coupon-redeemed': 'tag',
  'problem-created': 'alert-triangle',
  'display_external_input': 'globe',
  'api': 'webhook',
  'person': 'user',
  'person_check': 'user-check',
  'person_off': 'user-x',
  'person_cancel': 'user-x',
  'person_search': 'user-search',
  'user-check': 'user-check',
  'user-times': 'user-x',
  'groups': 'network',
  'partner_management': 'users',
  'customer': 'contact',
  'reseller': 'handshake',
  'queue': 'list-ordered',
  'profile': 'circle-user',
  'user': 'user',
  'users': 'users',
  'conference': 'users',

  // ============================================
  // Communication (Lovable: Bell, Mail, MessageSquare, Phone, Video)
  // ============================================
  'notification': 'bell',
  'notifications_off': 'bell-off',
  'bell': 'bell',
  'bell-ring': 'bell-ring',
  'mail': 'mail',
  'envelope': 'mail',
  'envelope-open': 'mail-open',
  'envelope-circle-check': 'mail',
  'phone': 'phone',
  'phone-call': 'phone-call',
  'call': 'phone-call',
  'phone-outgoing': 'phone-outgoing',
  'mobile': 'smartphone',
  'videocam': 'video',
  'video': 'video',
  'sms': 'message-square',
  'chat': 'message-circle',
  'inquiry': 'message-square',

  // ============================================
  // Actions (Lovable: Plus, Pencil, Trash2, Search, Filter, Copy, Save, Check, X)
  // ============================================
  'add': 'plus',
  'plus': 'plus',
  'circle-plus': 'circle-plus',
  'plus-circle': 'plus',
  'minus': 'minus',
  'edit': 'pencil',
  'pencil': 'pencil',
  'delete': 'trash-2',
  'trash': 'trash-2',
  'eraser': 'eraser',
  'search': 'search',
  'filter': 'filter',
  'download': 'download',
  'upload': 'upload',
  'cloud-upload-alt': 'upload',
  'refresh': 'refresh-cw',
  'rotate': 'rotate-cw',
  'check': 'check',
  'check_circle': 'check-circle-2',
  'check-circle': 'check-circle-2',
  'cancel': 'x-circle',
  'times-circle': 'x-circle',
  'block': 'ban',
  'copy': 'copy',
  'save': 'save',
  'play': 'play',
  'pause': 'pause',

  // ============================================
  // Status & Feedback (Lovable: Info, AlertTriangle, AlertCircle, CheckCircle2, Loader2, Shield)
  // ============================================
  'info': 'info',
  'info-circle': 'info',
  'help': 'help-circle',
  'help_outline': 'help-circle',
  'help_center': 'help-circle',
  'warning': 'alert-triangle',
  'triangle-exclamation': 'alert-triangle',
  'error': 'alert-circle',
  'complete_setup': 'check-circle-2',
  'emergency': 'siren',
  'loading': 'loader-2',
  'circle-notch': 'loader-2',
  'shield': 'shield',
  'shield_check': 'shield-check',
  'shield_alert': 'shield-alert',

  // ============================================
  // Business & Commerce (Lovable: Building2, MapPin, CreditCard, Receipt, Package, Euro)
  // ============================================
  'store': 'building-2',
  'stores': 'building-2',
  'company_profile': 'building-2',
  'building': 'building-2',
  'location': 'map-pin',
  'location-dot': 'map-pin',
  'map-marker-alt': 'map-pin',
  'map-marked-alt': 'map-pin',
  'payments': 'credit-card',
  'credit_card': 'credit-card',
  'coupons': 'tags',
  'billing': 'receipt',
  'featured_seasonal_and_gifts': 'gift',
  'gift': 'gift',
  'draft_orders': 'clipboard-list',
  'package': 'package',
  'package_2': 'package',
  'receipt': 'receipt',
  'banknote-arrow-up': 'banknote-arrow-up',
  'briefcase': 'briefcase',
  'dollar': 'euro',

  // ============================================
  // Settings & Security (Lovable: Settings, Settings2, Shield, Key, Lock, Eye, EyeOff, Globe, Palette, Database, Plug)
  // ============================================
  'setting': 'settings',
  'settings': 'settings',
  'settings2': 'settings-2',
  'cog': 'settings',
  'instant_mix': 'sliders-horizontal',
  'lock': 'lock',
  'lock_open': 'lock-open',
  'security': 'shield-check',
  '2fa': 'fingerprint',
  'fingerprint': 'fingerprint',
  'audit_logs': 'clipboard-list',
  'ip_whitelisting': 'shield-alert',
  'privacy': 'shield',
  'key': 'key',
  'eye': 'eye',
  'eye-slash': 'eye-off',
  'visibility': 'eye',
  'visibility_off': 'eye-off',
  'globe': 'globe',
  'palette': 'palette',
  'database': 'database',
  'plug': 'plug',

  // ============================================
  // Features & Integrations (Lovable: Plug, Webhook, Bot)
  // ============================================
  'webhook': 'webhook',
  'integrations': 'plug',
  'integration': 'plug',
  'workflow': 'git-branch',
  'code': 'code',
  'terminal': 'terminal',
  'internal-widget': 'layout-template',
  'widget': 'blocks',
  'bot': 'bot',
  'automation': 'bot',
  'templates': 'file-text',
  'postcode_import': 'map-pin',

  // ============================================
  // Support & Help (Lovable: HelpCircle, Headphones)
  // ============================================
  'support': 'help-circle',
  'contact_us': 'headphones',
  'academy_training_video': 'play-circle',
  'system_status': 'activity',
  'blog': 'bookmark',

  // ============================================
  // Analytics & Data (Lovable: BarChart3, TrendingUp)
  // ============================================
  'analytics': 'bar-chart-3',
  'analytics_appointment': 'chart-line',
  'chart': 'bar-chart-3',
  'chart-line': 'chart-line',
  'chart-no-axes-combined': 'chart-no-axes-combined',
  'trending_up': 'trending-up',
  'trending_down': 'trending-down',
  'gauge': 'gauge',

  // ============================================
  // Files & Documents (Lovable: FileText, FileSpreadsheet)
  // ============================================
  'file': 'file',
  'file_text': 'file-text',
  'file_spreadsheet': 'file-spreadsheet',
  'file-excel': 'file-spreadsheet',
  'document': 'file-text',
  'paperclip': 'paperclip',
  'attachment': 'paperclip',
  'description': 'file-text',

  // ============================================
  // Media (Lovable: Camera, Image, Youtube)
  // ============================================
  'camera': 'camera',
  'image': 'image',
  'youtube': 'youtube',

  // ============================================
  // Technology (Lovable: Monitor, Smartphone, Tablet, QrCode, Link)
  // ============================================
  'monitor': 'monitor',
  'smartphone': 'smartphone',
  'tablet': 'tablet',
  'qr-code': 'qr-code',
  'qr_code': 'qr-code',
  'link': 'link',
  'website': 'globe',

  // ============================================
  // Misc (Lovable: Star, LogOut, GripVertical, MoreVertical, MoreHorizontal, Sparkles, etc.)
  // ============================================
  'star': 'star',
  'logout': 'log-out',
  'login': 'log-in',
  'drag_indicator': 'grip-vertical',
  'more_vert': 'more-vertical',
  'more_horiz': 'more-horizontal',
  'ellipsis-v': 'more-vertical',
  'ellipsis-h': 'more-horizontal',
  'th': 'grid-3-x-3',
  'migration': 'arrow-right-left',
  'sparkles': 'sparkles',
  'lightbulb': 'lightbulb',
  'rocket': 'rocket',
  'target': 'target',
  'megaphone': 'megaphone',
  'grid': 'grid-3-x-3',
  'list': 'list',
  'columns-3': 'columns-3',
  'activity': 'activity',
  'zap': 'zap',
  'hash': 'hash',

  // ============================================
  // Sort Icons (Lovable: ArrowUpDown for sortable columns)
  // ============================================
  'sort': 'arrow-up-down',
  'arrow-up-down': 'arrow-up-down',
  'sort-indicator': 'arrow-up-down',

  // ============================================
  // Settings Sidebar Icons (Secondary Sidebar)
  // ============================================
  'widget_settings': 'settings',
  'widget_config': 'layout-template',
  'notification_active': 'bell-ring',
  'calendar_lock': 'hourglass',
  'master_data': 'sliders-horizontal',
  'event_repeat': 'repeat',
  'service': 'database',
  'travel_time_matrix': 'map',
  'booking_type': 'calendar-days',
  'booking_question': 'help-circle',
  'category': 'folder',
  'folder-plus': 'folder-plus',
  'appointment_status': 'circle-check-big',
  'customer_types': 'contact',
  'attributes': 'tag',
  'global_notification': 'bell-ring',
  'email_sms_history': 'history',
  'dashboard_customize': 'paintbrush',
  'design_booking_page': 'palette',
  'custom_css': 'braces',
  'whitelabel': 'wand-2',
  'highlight': 'star',
  'vat': 'percent',
  'hub': 'plug',
  'manage_api_key': 'key',
  'smart_action': 'zap',
  'utilization_report': 'chart-no-axes-combined',
  'booking_limits': 'gauge',
  'setup_assistant': 'rocket',
  'deal': 'handshake',
  'resource_import': 'upload',
  'role_permissions': 'user-cog',
  'setup_pricing_table': 'layout-grid',
  'for_you': 'puzzle',
  'past_invoices': 'file-down',
  'role_import': 'folder-plus',
  'release_notes': 'file-text',
  'subscriptions': 'wallet',

  // Queue counter actions — Font Awesome-style aliases used by calio-mat-icon
  // (which `<app-calio-flat-button [icon]>` routes through). Without these
  // mappings the button renders empty / falls back to a generic glyph.
  'redo': 'rotate-cw',
  'exchange-alt': 'arrow-right-left',
  'random': 'shuffle',
};

/**
 * Converts a kebab/snake/spaced icon name to the PascalCase key used in LUCIDE_ICONS.
 *
 * This mirrors `LucideAngularModule`'s own conversion (its `toPascalCase`) on purpose:
 * because the algorithm is identical, a name accepted by `isRegisteredLucideIcon` is
 * guaranteed to resolve inside `<lucide-icon [name]>`, and one it rejects is guaranteed
 * not to. Approximating the conversion here would reintroduce the silent-empty-icon
 * failure it exists to remove.
 */
const toPascalCase = (name: string): string =>
  name.replace(
    /(\w)([a-z0-9]*)(_|-|\s*)/g,
    (_match, head: string, tail: string) => head.toUpperCase() + tail.toLowerCase()
  );

/**
 * Legacy names that ship their OWN custom SVG asset AND happen to PascalCase onto a
 * registered Lucide icon. The Lucide fallback must not claim these, or the call site
 * silently swaps a bespoke filled Material-style glyph for a Lucide stroke one.
 *
 * Found the hard way: `bar_chart` and `hourglass` reached the Analytics metric cards, the
 * analytics teaser and the blurred-preview screen — none of which pass a literal
 * `iconType="…"`. They pass it through a WRAPPER input (`app-analytics-metric-card`'s
 * `iconName`), so the original blast-radius sweep — which only grepped literal
 * `icon=`/`iconType=` attributes in templates — reported "exactly 1 name changes" and
 * missed them. The list below was rebuilt from the registered SVG assets instead of from
 * call sites, precisely so pass-through bindings cannot hide.
 *
 * Add a name here if it has a real SVG in `src/assets` and must keep it.
 */
const SVG_OWNED_NAMES: ReadonlySet<string> = new Set([
  'bar_chart',
  'hourglass',
  'circle',
  'Upload',
]);

/**
 * True when `name` is a Lucide icon registered in LUCIDE_ICONS and is not a legacy name
 * that owns a custom SVG.
 *
 * ICON_NAME_MAPPING is an ALIAS table, not the icon vocabulary: it exists so legacy
 * FontAwesome-era `iconType` values ('close', 'exchange-alt') keep resolving. Treating
 * it as the vocabulary left 75 of the 238 registered icons — Trash, Send, Home, Sun,
 * Maximize2 among them — unreachable from `calio-mat-icon`, where they fell through to
 * a non-existent `svgIcon` and rendered NOTHING, with a green build and a green lint.
 * Consumers should check the alias table first, then fall back to this.
 */
export const isRegisteredLucideIcon = (name: string): boolean =>
  !!name && !SVG_OWNED_NAMES.has(name) && toPascalCase(name) in LUCIDE_ICONS;
